import { useTranslation } from 'react-i18next';
import { cn } from '@packages/utils';

/** DE/EN segmented toggle, wired to i18next. Two visual skins:
 * `festival` (charcoal/paper) and `event` (inherits --ev-* colors). */
export function LangToggle({ variant = 'festival' }: { variant?: 'festival' | 'event' }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('en') ? 'EN' : 'DE';
  const set = (lng: 'de' | 'en') => i18n.changeLanguage(lng);

  const langs: { code: 'de' | 'en'; label: 'DE' | 'EN' }[] = [
    { code: 'de', label: 'DE' },
    { code: 'en', label: 'EN' },
  ];

  return (
    <div className="inline-flex shrink-0" role="group" aria-label="Sprache / Language">
      {langs.map(({ code, label }, i) => {
        const active = current === label;
        if (variant === 'event') {
          return (
            <button
              key={code}
              type="button"
              onClick={() => set(code)}
              className="ev-mono"
              style={{
                fontSize: 12,
                fontWeight: 600,
                padding: '6px 11px',
                marginLeft: i ? -1 : 0,
                border: '1px solid var(--ev-line)',
                background: active ? 'var(--ev-accent)' : 'transparent',
                color: active ? 'var(--ev-accent-ink)' : 'var(--ev-ink)',
                cursor: 'pointer',
              }}>
              {label}
            </button>
          );
        }
        return (
          <button
            key={code}
            type="button"
            onClick={() => set(code)}
            className={cn('font-mono')}
            style={{
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: '.08em',
              padding: '6px 11px',
              marginLeft: i ? -2 : 0,
              border: '2px solid var(--ww-charcoal)',
              background: active ? 'var(--ww-charcoal)' : 'transparent',
              color: active ? 'var(--paper-50)' : 'var(--ww-charcoal)',
              cursor: 'pointer',
              lineHeight: 1,
            }}>
            {label}
          </button>
        );
      })}
    </div>
  );
}
